// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"679":"a611c5ca","856":"b83bb58a","965":"61f3d348"}[chunkId] + ".js";
};